import React, { useMemo } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';

const RENKLER = ['#2563eb', '#0d9488', '#d97706', '#7c3aed', '#16a34a', '#e11d48', '#1e3a8a'];
const DIGER_RENK = '#94a3b8';

const sayi = (n) => Number(n || 0).toLocaleString('tr-TR');
const yuzde = (parca, toplam) => (toplam > 0 ? Math.round((parca / toplam) * 100) : 0);

const ArizaHalka = ({ veri, loading }) => {
  const toplam = veri?.toplam || 0;
  const dilimler = useMemo(() => {
    const named = (veri?.dilimler || []).map((d, i) => ({
      id: d.id,
      ad: d.ad,
      adet: d.adet,
      renk: RENKLER[i % RENKLER.length],
    }));
    if (veri?.diger?.adet) {
      named.push({
        id: 'diger',
        ad: 'Diğer',
        adet: veri.diger.adet,
        kalem: veri.diger.kalem,
        renk: DIGER_RENK,
      });
    }
    return named;
  }, [veri]);

  return (
    <section className="ia-chart-card">
      <header className="ia-chart-head">
        <h2>Dağılım</h2>
        <span>{sayi(toplam)}</span>
      </header>
      {loading && !veri ? (
        <div className="ia-chart-empty">Yükleniyor</div>
      ) : toplam <= 0 ? (
        <div className="ia-chart-empty">Bu dönemde kayıt yok</div>
      ) : (
        <div className="ia-halka">
          <div className="ia-halka-plot">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={dilimler}
                  dataKey="adet"
                  nameKey="ad"
                  innerRadius="58%"
                  outerRadius="82%"
                  paddingAngle={2}
                  stroke="none"
                >
                  {dilimler.map((d) => (
                    <Cell key={d.id} fill={d.renk} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(v, _n, item) => [sayi(v), item?.payload?.ad]}
                  contentStyle={{
                    borderRadius: 10,
                    border: '1px solid var(--border-color)',
                    fontSize: 13,
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className="ia-halka-merkez">
              <span className="ia-halka-toplam">{sayi(toplam)}</span>
              <span className="ia-halka-etiket">toplam</span>
            </div>
          </div>
          <ul className="ia-legend">
            {dilimler.map((d) => (
              <li key={d.id} title={d.ad}>
                <span className="ia-legend-dot" style={{ background: d.renk }} />
                <span className="ia-legend-ad">{d.ad}</span>
                <span className="ia-legend-adet">{sayi(d.adet)}</span>
                <span className="ia-legend-yuzde">%{yuzde(d.adet, toplam)}</span>
                {d.kalem ? <span className="ia-legend-kalem">{sayi(d.kalem)} kalem</span> : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default ArizaHalka;
